var _rect, _text, _g, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg105(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uBC88\uD638\uAD6C\uAC04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#eef7f5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 34,
    fontWeight: 900,
    fill: "#172033"
  }, "1\uBD80\uD130 45\uAE4C\uC9C0 \uC138 \uAD6C\uAC04\uC73C\uB85C \uBCF4\uAE30")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 135,
    width: 205,
    height: 190,
    rx: 24,
    fill: "#fff1bd",
    stroke: "#e0a72b",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 220,
    fontSize: 48,
    fontWeight: 900,
    fill: "#172033"
  }, "1~15"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 272,
    fontSize: 26,
    fontWeight: 800,
    fill: "#7c4a03"
  }, "\uC800\uBC88\uD638"), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 135,
    width: 205,
    height: 190,
    rx: 24,
    fill: "#dff4ef",
    stroke: "#0f766e",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 220,
    fontSize: 48,
    fontWeight: 900,
    fill: "#172033"
  }, "16~30"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 272,
    fontSize: 26,
    fontWeight: 800,
    fill: "#0f766e"
  }, "\uC911\uAC04\uBC88\uD638"), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 135,
    width: 205,
    height: 190,
    rx: 24,
    fill: "#e9e1ff",
    stroke: "#8065c7",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 220,
    fontSize: 48,
    fontWeight: 900,
    fill: "#172033"
  }, "31~45"), /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 272,
    fontSize: 26,
    fontWeight: 800,
    fill: "#634ca8"
  }, "\uACE0\uBC88\uD638"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 372h600",
    stroke: "#172033",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 372,
    r: 15,
    fill: "#e0a72b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 372,
    r: 15,
    fill: "#0f766e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 372,
    r: 15,
    fill: "#8065c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg105);
export default __webpack_public_path__ + "static/media/105-번호구간.b2c7f2fe9f52c9be687e975da67c3e8c.svg";
export { ForwardRef as ReactComponent };